import { useLocalStorageValue } from "@react-hookz/web";
import { useCallback } from "react";

import type { Permissions } from "./use-permissions";

export function usePermissionOverrides(): {
  overrides: Partial<Pick<Permissions, "ce_admin" | "super_admin">>;
  setOverride: (key: keyof Permissions, val?: boolean) => void;
  clearOverrides: () => void;
} {
  const { value, set } = useLocalStorageValue<
    Partial<Pick<Permissions, "ce_admin" | "super_admin">>
  >("permissions", {});

  const setOverride = useCallback(
    (key: keyof Permissions, val?: boolean) => {
      set((prev) => ({
        ...prev,
        [key]: val,
      }));
    },
    [set],
  );

  const clearOverrides = useCallback(() => {
    set({});
  }, [set]);

  return {
    overrides: value ?? {},
    setOverride,
    clearOverrides,
  };
}
